import { Route, RouteObject } from 'react-router';

/**
 * Generate a stable key for a route based on its path
 * This prevents React from incorrectly reusing components when routes change
 */
const getRouteKey = (route: RouteObject, index: number): string => {
  if (route.index) {
    return `index-${index}`;
  }
  // Use path as key, fallback to index if path is undefined
  return route.path ? `route-${route.path}` : `route-${index}`;
};

export const renderRoutes = (routes: RouteObject[]) => {
  return routes.map((route, index) => {
    const { path, element, children, index: isIndex } = route;
    const key = getRouteKey(route, index);

    if (isIndex) {
      return <Route key={key} index element={element} />;
    }

    if (children) {
      return (
        <Route key={key} path={path} element={element}>
          {renderRoutes(children)}
        </Route>
      );
    }

    return <Route key={key} path={path} element={element} />;
  });
};
